'use strict';
'use client';
import { j as r } from "../../external/react/jsx-runtime.js";
import a from "../../external/classnames/index.js";
import i from "./TimelineStep.js";
const c = ({ steps: t, disablePadding: s }) => /* @__PURE__ */ r.jsx(
  "div",
  {
    className: a("flex flex-col", {
      "px-4 py-8 md:px-6": !s
    }),
    children: t.map((m, e) => /* @__PURE__ */ r.jsx(
      i,
      {
        step: m.step,
        First: e === 0,
        Last: e === t.length - 1,
        active: m.active
      },
      e
    ))
  }
);
export {
  c as default
};
